import React, { Component } from 'react'
import GoogleBtn from '../login/GoogleBtn';
import GoogleGtmSelection from './GoogleGtmSelection';
import MonitorContainer from './MonitorContainer'
import {GoogleAPI, GetliveGTMpayload } from '../utils/util-networkCalls.js';
import SlackBtn from './SlackBtn';
import {SetWindowVars, TagDataTableArray, VariableDataTableArray, TriggerDataTableArray} from '../utils/util-reformatingContainer';

//const dotenv = require('dotenv');
//const env = dotenv.config();

class Ops extends Component {

  constructor(props) {

    super(props);

    this.state = {
      authstate: {googleAccessToken:undefined},
    };
  }

  getGoogleAccessToken = (authstate) => {
    this.setState({authstate: authstate });
  }
  getAccountObject = (accountObject) =>{
    this.setState({accountObject: accountObject});
  }
  getContainerObject = (containerObject) =>{
    this.setState({containerObject: containerObject});
  }
  getSlackWebhook = (url) =>{
    this.setState({slackWebhook: url});
  }

  componentDidUpdate(prevProps, prevState, snapshot){

    // Updates the Container File when a new container is selected
    if(this.state.containerObject !== prevState.containerObject){
        let containerObject = this.state.containerObject;

        GoogleAPI(containerObject.path+'/versions:live',this.state.authstate.googleAccessToken)
        .then(response =>{

          let tagDataTable = TagDataTableArray(response);
          let variableDataTable =VariableDataTableArray(response);
          let triggerDataTable = TriggerDataTableArray(response);
          let gtmPayload = GetliveGTMpayload(this.state.containerObject.publicId);

          let windowData = {
                            "container":response,
                            "tagData": tagDataTable,
                            "variableData": variableDataTable,
                            "triggerData": triggerDataTable,
                            "gtmPayLoad": gtmPayload
                           };

          SetWindowVars(windowData,false);

          this.setState({
              gtmPayLoad: gtmPayload,
              liveContainerConfig: response,
              tagDataTable:tagDataTable,
              variableDataTable:variableDataTable,
              triggerDataTable:triggerDataTable
          });
        });
      }
  }

  render(){
    return (
      <div className="App">
        <header className="App-header">
           <GoogleBtn label = "Login in" googleAccessToken={this.getGoogleAccessToken}/>
           <br/>

           <SlackBtn
             getSlackWebhook = {this.getSlackWebhook}
           />
           <GoogleGtmSelection
               googleAccessToken = {this.state.authstate.googleAccessToken}
               getAccountObject = {this.getAccountObject}
               accountObject = {this.state.accountObject}
               getContainerObject = {this.getContainerObject}
          />
          <MonitorContainer
              authState = {this.state.authstate}
              containerObject = {this.state.containerObject}
              liveVersion = {this.state.liveContainerConfig}
          />
          <div>
          <br/><br/>

              User Access Token: {this.state.authstate.googleAccessToken}<br/><br/>
              Account Object: {JSON.stringify(this.state.accountObject)}<br/><br/>
              Container Object: {JSON.stringify(this.state.containerObject)}<br/><br/>
              Slack Webhook: {this.state.slackWebhook}<br/><br/>
          <br/><br/>



          </div>
        </header>

      </div>

    );
  }
}

export default Ops;
